<template>
  <div v-focus class="sign-out" tabindex="0" @keyup.esc="$emit('exit', false)">
    <!-- <img src="@/assets/signout/exitBallon.png" alt="" /> -->
    <div class="body">
      <div class="info">
        <h1>{{ $t('messages.areYouSure') }}</h1>
        <h1>{{ $t('messages.endSession') }}</h1>
        <div class="buttons">
          <button type="button" class="btn btn-danger" @click="$emit('exit', true)">
            {{ $t('messages.yes') }}
          </button>
          <button type="button" class="btn btn-primary" @click="$emit('exit', false)">
            {{ $t('messages.no') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.sign-out {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .body {
    background-image: url('~@/assets/signout/exitBallon.png');
    background-size: 100% 100%;
    height: 300px;
    width: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    .info {
      position: absolute;
      h1 {
        text-align: center;
        width: 350px;
        &:first-child {
          font-family: 'comfortaabold';
          font-size: 25px;
        }
        font-size: 20px;
      }
      .buttons {
        padding: 15px 35px;
        display: flex;
        justify-content: space-between;
        button {
          width: 115px;
          height: 30px;
          line-height: 1;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
